<template>
  <span class="svg-icon-sticker-tab" :style="iconStyle">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.125 1.5C2.67 1.5 1.5 2.67 1.5 4.125V13.875C1.5 15.33 2.67 16.5 4.125 16.5H12L16.5 12V4.125C16.5 2.67 15.33 1.5 13.875 1.5H4.125ZM4.3125 3H13.6875C14.0356 3 14.3694 3.13828 14.6156 3.38442C14.8617 3.63056 15 3.9644 15 4.3125V11.25H13.875C12.42 11.25 11.25 12.42 11.25 13.875V15H4.3125C3.9644 15 3.63056 14.8617 3.38442 14.6156C3.13828 14.3694 3 14.0356 3 13.6875V4.3125C3 3.9644 3.13828 3.63056 3.38442 3.38442C3.63056 3.13828 3.9644 3 4.3125 3ZM10.83 5.0775C10.71 5.0775 10.59 5.0925 10.4775 5.1225C9.7725 5.3175 9.375 6.0375 9.555 6.75C9.5925 6.8625 9.645 6.975 9.7125 7.08L12.135 6.42C12.135 6.2925 12.12 6.165 12.09 6.0375C11.9325 5.475 11.415 5.0775 10.83 5.0775ZM6.1275 6.375C6 6.375 5.8875 6.375 5.775 6.4125C5.0775 6.6075 4.665 7.3275 4.8525 8.025C4.875 8.145 4.9425 8.25 5.01 8.37L7.4325 7.71C7.4325 7.5825 7.4175 7.455 7.3875 7.335C7.23 6.75 6.7125 6.375 6.1275 6.375ZM12.54 8.445L5.6925 10.3275C6.6825 11.475 8.25 11.955 9.7125 11.5575C11.175 11.1525 12.27 9.9375 12.54 8.445Z" fill="#FF2E38"/>
    </svg>
  </span>
</template>

<script>
import { computed } from 'vue'
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  },

  computed: {
    iconStyle () {
      return {
        '--iconColor': this.color,
        'width': `${this.width}px`,
        'height': `${this.width}px`,
        'fill': 'none'
      }
    }
  }
}
</script>

<style lang="scss">
  .svg-icon-sticker-tab {
    display: flex;
    justify-content: left;
    align-items: center;

    path {
      fill: var(--iconColor)
    }
  }
</style>
